import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import GameGrid from './components/GameGrid';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homepageStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '火影同人游戏合集',
      url: 'https://naruto-fangame.com/',
      description: '探索最热门的火影同人游戏，涵盖角色扮演、格斗、策略等多种玩法。火影同人游戏汇聚海量忍者世界内容，让你以全新方式体验鸣人、佐助等经典角色的冒险故事，立即免费畅玩！',
      email: 'contact@naruto-fangame.com',
      foundingDate: '2024',
    },
    {
      '@type': 'WebPage',
      name: '火影同人游戏-最受欢迎的火影同人游戏合集',
      description: '探索最热门的火影同人游戏，涵盖角色扮演、格斗、策略等多种玩法。火影同人游戏汇聚海量忍者世界内容，让你以全新方式体验鸣人、佐助等经典角色的冒险故事，立即免费畅玩！',
      url: 'https://naruto-fangame.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '火影同人游戏合集',
        url: 'https://naruto-fangame.com/',
      },
      about: {
        '@type': 'Organization',
        name: '火影同人游戏合集',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '火影同人游戏是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '火影同人游戏是基于《火影忍者》动漫世界观，由粉丝或独立开发者创作的非官方游戏作品。这些游戏涵盖角色扮演（RPG）、格斗对战、策略养成、冒险探索等多种类型，通常免费提供给玩家体验。',
          },
        },
        {
          '@type': 'Question',
          name: '火影同人游戏需要付费吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '大部分火影同人游戏都是免费畅玩的。这些火影同人免费游戏通常通过广告或自愿赞助来维持运营。核心游戏内容都是免费提供的。',
          },
        },
        {
          '@type': 'Question',
          name: '如何选择适合自己的火影同人游戏？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '选择火影同人游戏时，可以先确定自己喜欢什么类型的玩法。如果你喜欢沉浸式剧情，可以选择火影同人角色扮演游戏；如果你喜欢快节奏对战，火影同人格斗游戏会更适合你。',
          },
        },
        {
          '@type': 'Question',
          name: '火影同人游戏可以在手机上玩吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '当然可以！目前市面上有大量的火影同人手游可供选择。这些火影同人手机游戏针对触屏操作进行了优化，让你随时随地都能体验忍者世界的乐趣。',
          },
        },
        {
          '@type': 'Question',
          name: '火影同人格斗游戏有在线对战功能吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '许多热门的火影同人格斗游戏都支持在线PVP对战。你可以与来自世界各地的玩家进行实时忍术对决，测试自己的操作技术和角色理解。',
          },
        },
        {
          '@type': 'Question',
          name: '如何下载火影同人游戏？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '火影同人游戏下载方式因游戏而异。网页版火影同人游戏通常直接在浏览器中运行，PC端游戏可以通过官方网站或游戏平台下载安装包，火影同人手游则可以通过应用商店搜索下载。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <GameGrid />
        <ArticleList />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(homepageStructuredData),
        }}
      />
    </>
  );
}